import styled, { css } from "styled-components";
import { Button, Table, Tabs } from "antd";

export const OrderStatusBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px 10px;
  border-radius: 5px;
  font-family: "Inter", sans-serif;
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
  white-space: nowrap;

  ${({ variant }) => {
    switch (variant) {
      case "canceled":
        return css`
          color: rgb(172, 32, 32);
          background-color: rgb(253, 236, 236);
        `;
      case "pending":
        return css`
          color: rgb(180, 120, 0);
          background-color: rgb(255, 247, 230);
        `;
      case "confirmed":
      default:
        return css`
          color: rgb(21, 128, 61);
          background-color: rgb(223, 246, 231);
        `;
    }
  }}
`;

export const TableWrapper = styled.div`
  width: 100%;
  padding-bottom: 80px;
  @media (max-width: 1200px) {
    max-width: 90%;
  }

  @media (max-width: 768px) {
    min-width: 80%;
    max-width: 80%;
  }

  @media (max-width: 480px) {
    min-width: 95%;
    max-width: 95%;
  }
`;

export const DropdownButton = styled.div`
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  background: white;
  transition: all 0.3s;
  margin-top: 8px;
  margin-bottom: 25px;

  &:hover {
    border-color: #40a9ff;
  }
`;
export const CustomTable = styled(Table)`
  padding-bottom: 15px;
  padding: 8px;
  width: 700px;
  border: 1px solid rgba(226, 232, 240, 1);
  border-radius: 10px;
  // overflow: hidden;

  .ant-table-container {
    border-radius: 10px;
    overflow: hidden;
  }
  .ant-table {
    border-radius: 10px;
    overflow: hidden;
  }
  .ant-table-tbody > tr:last-child > td {
    border-bottom: none !important;
  }

  .ant-table-tbody > tr > td:first-child {
    color: rgba(49, 65, 88, 1);
    font-size: 18px;

    font-family: "Inter";
    font-weight: 600;
    line-height: 100%;
    letter-spacing: 0%;
  }

  .ant-table-tbody > tr > td:last-child {
    font-weight: normal;
    color: rgba(98, 116, 142, 1);
    font-size: 18px;

    font-family: "Inter";
    font-weight: 400;
    line-height: 100%;
    letter-spacing: 0%;
  }

  @media (max-width: 1200px) {
    .ant-table-tbody > tr > td:first-child,
    .ant-table-tbody > tr > td:last-child {
      font-size: 14px;
    }
  }

  @media (max-width: 768px) {
    .ant-table-tbody > tr > td:first-child,
    .ant-table-tbody > tr > td:last-child {
      font-size: 12px;
    }
  }

  @media (max-width: 480px) {
    .ant-table-tbody > tr > td:first-child,
    .ant-table-tbody > tr > td:last-child {
      font-size: 10px;
    }
  }
`;

export const ProductsAndServicesCustomTable = styled(Table)`
  width: 100%;
  margin: 0 auto;
  overflow-x: auto;

  .ant-table-container {
    max-width: 100%; /* Permite que a tabela use 100% da largura do contêiner pai */
  }

  .ant-table-thead > tr > th {
    background-color: white !important;
    font-family: "Inter", sans-serif;
    font-weight: 600;
    font-size: 16px;
    line-height: 100%;
    white-space: nowrap;
    text-align: left;
  }

  .ant-table-tbody > tr:nth-child(odd) {
    background-color: rgba(226, 226, 247, 0.2);
  }

  .ant-table-tbody > tr:nth-child(even) {
    background-color: white;
  }

  .ant-table-tbody > tr > td {
    font-size: 16px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  @media (max-width: 1200px) {
    .ant-table-thead > tr > th {
      font-size: 14px;
    }

    .ant-table-tbody > tr > td {
      font-size: 14px;
    }
  }

  @media (max-width: 768px) {
    .ant-table-thead > tr > th {
      font-size: 12px;
    }

    .ant-table-tbody > tr > td {
      font-size: 12px;
    }

    .ant-table-container {
      overflow-x: scroll;
    }
  }

  @media (max-width: 480px) {
    .ant-table-thead > tr > th {
      font-size: 10px;
    }

    .ant-table-tbody > tr > td {
      font-size: 10px;
    }

    .ant-table-container {
      overflow-x: scroll; /* Habilita rolagem horizontal em telas muito pequenas */
    }
  }

  thead .ant-table-cell {
    color: #314158 !important;
    font-family: "Inter", sans-serif !important;
    font-weight: 600 !important;
    font-size: 16px !important;
    line-height: 100% !important;
    letter-spacing: 0% !important;
  }

  tbody .ant-table-cell {
    color: #314158 !important;
    font-family: "Inter", sans-serif !important;
    font-weight: 400 !important;
    font-size: 16px !important;
    line-height: 100% !important;
    letter-spacing: 0% !important;
  }

  .ant-table-cell {
    border-right: 0 !important;
  }
`;

export const StyledTabs = styled(Tabs)`
  .ant-tabs-tab {
    font-size: 16px;
    color: rgba(98, 116, 142, 1);
  }

  @media (max-width: 1200px) {
    .ant-tabs-tab {
      font-size: 14px;
    }
  }

  @media (max-width: 768px) {
    .ant-tabs-tab {
      font-size: 12px;
    }
  }

  @media (max-width: 480px) {
    .ant-tabs-tab {
      font-size: 10px;
    }
  }
`;
export const ButtonFormConfirm = styled(Button)`
  font-family: "Inter", sans-serif;
  border-radius: 10px;
  border: none;
  font-weight: 600;
  font-size: 14px;

  color: #002244;

  &:disabled {
    background-color: #d3d3d3 !important;
    color: #a1a1a1 !important;
    border: none !important;
    cursor: not-allowed;
  }
`;

export const ProductServiceTableWrapper = styled.div`
  margin: 8px 0 24px 0;
  display: grid;
  gap: 24px;
  padding-bottom: 50px;

  .ant-table.ant-table-bordered > .ant-table-container {
    border-left: 0;
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid var(--stroke-soft, #e2e8f0);
  }
  .ant-table-content,
  .ant-table-content table {
  }

  .ant-table.ant-table-bordered
    > .ant-table-container
    > .ant-table-content
    > table,
  .ant-table.ant-table-bordered
    > .ant-table-container
    > .ant-table-header
    > table {
    border: 0;
  }
`;
